import ProfessionalIcon from "../../../../../../../../../../assets/svg/professional-icon";
import StudentIcon from "../../../../../../../../../../assets/svg/student-icon";

export const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const leadScoreRangesConfig = [
  {
    id: "0-20",
    range: "0-20",
    description: "Cold Lead → Unqualified",
    color: "text-verba-red-alert dark:text-verba-red-alert-dk",
    min_score: 0,
    max_score: 20,
  },
  {
    id: "21-40",
    range: "21-40",
    description: "Low Quality Lead → Minimal Fit, Low Engagement",
    color: "text-lead-stage-in-progress dark:text-lead-stage-in-progress-dk",
    min_score: 21,
    max_score: 40,
  },
  {
    id: "41-60",
    range: "41-60",
    description: "Warm Lead → Some Fit, Moderate Engagement",
    color: "text-tag-yellow-bg dark:text-tag-yellow-bg-dk",
    min_score: 41,
    max_score: 60,
  },
  {
    id: "61-80",
    range: "61-80",
    description: "Hot Lead → Good Fit, High Engagement",
    color: "text-lead-stage-engaged dark:text-lead-stage-engaged-dk",
    min_score: 61,
    max_score: 80,
  },
  {
    id: "81-100",
    range: "81-100",
    description: "Best Fit, High Intent",
    color: "text-verba-green-success dark:text-verba-green-success-dk",
    min_score: 81,
    max_score: 100,
  },
];

export const leadTypesConfig = [
  {
    id: "student_only",
    name: "Student",
    color: "text-verba-mail dark:text-verba-mail-dk",
    icon: StudentIcon,
  },
  {
    id: "working_professionals",
    name: "Professional",
    color: "text-analytics-safety dark:text-analytics-safety-dk",
    icon: ProfessionalIcon,
  },
];
